import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hour4u-admin-workflow-popup',
  templateUrl: './workflow-popup.component.html',
  styleUrls: ['./workflow-popup.component.scss']
})
export class WorkflowPopupComponent implements OnInit {
  @Output() workflowSetup = new EventEmitter<any>();

  selectedWorkflow: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<WorkflowPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  selectWorkflow(workflow: string) {
    this.selectedWorkflow = this.selectedWorkflow === workflow ? null : workflow;
  }

  setupWorkflow(data) {
    console.log("data", data);
    // Emit both the data and the selected workflow type
    this.workflowSetup.emit({
      data: data,
      workflowType: this.selectedWorkflow
    });
    this.dialogRef.close();
  }
}
